<template>
  <div ref="modalw" class="modal-wrapper">
    <a-modal
      :title="null"
      :visible="showLogin"
      :footer="null"
      :centered="true"
      :get-container="() => $refs.modalw"
      :width="662"
      wrap-class-name="modal-content"
      @cancel="handleCancel"
    >
      <div>
        <div class="title"></div>
        <a-form
          class="form"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 18 }"
          :form="form"
          @submit="handleSubmit"
          v-if="!isLogin"
        >
          <a-form-item label="产品选择">
            <a-select
              v-model:value="selectValueType"
              style="width: 421px;"
              placeholder="请选择"
              @change="changeProduct"
            >
              <a-select-option :value="'1'">千橙ERP</a-select-option>
              <a-select-option :value="'2'">千橙收银</a-select-option>
              <a-select-option :value="'3'">千橙连锁</a-select-option>
              <a-select-option :value="'4'">千橙微商城</a-select-option>
              <a-select-option :value="'5'">汇团团</a-select-option>
              <a-select-option :value="'6'">千橙分销</a-select-option>
              <a-select-option :value="'7'">千橙S2B2C</a-select-option>
              <a-select-option :value="'8'">千橙B2b分销</a-select-option>
              <a-select-option :value="'9'">汇好看直播</a-select-option>
              <a-select-option :value="'10'">千橙数字人</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item
            label="公司名称"
            v-if="
              selectValueType == '6' ||
              selectValueType == '7' ||
              selectValueType == '8' ||
              selectValueType == '9' ||
              selectValueType == '10'
            "
          >
            <a-input
              v-decorator="[
                'storeName',
                { rules: [{ required: true, message: '请输入公司名称!' }] },
              ]"
              :maxLength="20"
              placeholder="请输入1-20个字符"
            />
          </a-form-item>
          <a-form-item
            label="店铺名称"
            v-if="
              selectValueType == '1' ||
              selectValueType == '2' ||
              selectValueType == '3' ||
              selectValueType == '4' ||
              selectValueType == '5'
            "
          >
            <a-input
              v-decorator="[
                'storeName',
                { rules: [{ required: true, message: '请输入店铺名称!' }] },
              ]"
              :maxLength="20"
              placeholder="请输入1-20个字符"
            />
          </a-form-item>
          <!-- <a-form-item label="店铺名称">
              <a-input
                v-decorator="[
                  'address',
                  { rules: [{ required: true, message: '请输入所在城市!' }] },
                ]"
                placeholder="请输入所在城市"
              />
            </a-form-item> -->

          <a-form-item label="手机号">
            <a-input
              v-decorator="[
                'phone',
                {
                  rules: [
                    {
                      required: true,
                      message: '请输入手机号!',
                    },
                    {
                      validator: checktelphone,
                    },
                  ],
                },
              ]"
              placeholder="输入手机号码"
            />
          </a-form-item>
          <a-form-item label="验证码">
            <a-input-search
              v-decorator="[
                'messageCode',
                { rules: [{ required: true, message: '请输入短信验证码!' }] },
              ]"
              placeholder="短信验证码"
              size="large"
              @search="sendMessage"
            >
              <a-button slot="enterButton" :disabled="!isShowGetCode">
                <template v-if="isShowGetCode">获取验证码</template>
                <template v-else>{{ countdown }}s后可重试</template>
              </a-button>
            </a-input-search>
          </a-form-item>
          <a-form-item
            label="密码"
            v-if="
              selectValueType != '5' &&
              selectValueType != '6' &&
              selectValueType != '7' &&
              selectValueType != '8' &&
              selectValueType != '9' &&
              selectValueType != '10'
            "
          >
            <a-input-password
              v-decorator="[
                'password',
                {
                  rules: [
                    {
                      required: true,
                      message: '支持8-32数字+字母组合密码!',
                    },
                    {
                      validator: checkPassword,
                    },
                  ],
                },
              ]"
              :maxLength="32"
              placeholder="支持8-32数字+字母组合密码"
            />
          </a-form-item>
          <a-form-item label="用户姓名">
            <a-input
              v-decorator="[
                'userName',
                { rules: [{ required: true, message: '请输入用户名称!' }] },
              ]"
              placeholder="请输入用户名称"
            />
          </a-form-item>
          <a-form-item label="咨询留言">
            <a-input
              v-decorator="['informationExplain']"
              :style="{
                height: '100px',
              }"
              type="textarea"
              placeholder="如果您对我们的产品有任何问题，可以留下咨询信息"
            />
          </a-form-item>
          <!-- <a-form-item>
              <div class="statement">
                隐私声明：<br>
                接受通过此手机接收相关的产品信息和咨询，汇通数科不会将您的信息进行商用或者透露给第三方，请放心填写。
              </div>
            </a-form-item> -->
          <a-form-item>
            <a-button
              type="primary"
              html-type="submit"
              class="submit-btn"
              v-if="(selectValueType == '5' || selectValueType == '6') && !isErr"
            >
              提交申请
            </a-button>
            <a-button
              type="primary"
              html-type="submit"
              class="submit-btn"
              v-if="
                (selectValueType == '1' ||
                  selectValueType == '2' ||
                  selectValueType == '3' ||
                  selectValueType == '4' ||
                  selectValueType == '7' ||
                  selectValueType == '8' ||
                  selectValueType == '9' ||
                  selectValueType == '10' ||
                  selectValueType == '') &&
                !isErr
              "
            >
              提交注册
            </a-button>
            <a-button class="submit-btn" @click="goPath" v-if="isErr"
              >登录体验</a-button
            >
          </a-form-item>
        </a-form>
        <div class="toPath" v-else>
          <div class="product">
            <div class="product_label">产品选择:</div>
            <div class="product_value">
              <a-select
                v-model:value="selectValueType"
                style="width: 421px"
                :disabled="isChangeProduct"
                placeholder="请选择"
                @change="changeProduct"
              >
              <a-select-option :value="'1'">千橙ERP</a-select-option>
              <a-select-option :value="'2'">千橙收银</a-select-option>
              <a-select-option :value="'3'">千橙连锁</a-select-option>
              <a-select-option :value="'4'">千橙微商城</a-select-option>
              <a-select-option :value="'5'">汇团团</a-select-option>
              <a-select-option :value="'6'">千橙分销</a-select-option>
              <a-select-option :value="'7'">千橙S2B2C</a-select-option>
              <a-select-option :value="'8'">千橙B2b分销</a-select-option>
              <a-select-option :value="'9'">汇好看直播</a-select-option>
              <a-select-option :value="'10'">千橙数字人</a-select-option>
              </a-select>
            </div>
          </div>
          <img
            class="code_img1"
            src="@/assets/images/login/code1.png"
            v-if="selectValueType == '4'"
            alt=""
          />
          <img
            class="code_img1"
            src="@/assets/images/login/code2.png"
            v-if="selectValueType == '2'"
            alt=""
          />
          <img
            class="code_img1"
            src="@/assets/images/login/code4.png"
            v-if="selectValueType == '5'"
            alt=""
          />
          <img
            class="code_img2"
            src="@/assets/images/login/code5.png"
            v-if="selectValueType == '6'"
            alt=""
          />
          <img
            class="code_img1"
            src="@/assets/images/login/code6.png"
            v-if="selectValueType == '10'"
            alt=""
          />
          <div
            class="code_text"
            v-if="
              selectValueType == '2' ||
              selectValueType == '4' 
            "
          >
            注册成功，立即下载体验{{ productTitle[Number(selectValueType)] }}
          </div>
          <div
            class="code_text"
            v-if="
              selectValueType == '10'
            "
          >
            扫码下载，内测体验
          </div>
          <div class="code_text" v-if="selectValueType == '5'">欢迎扫码体验</div>
          <div
            class="submit-btn1"
            v-if="selectValueType == '6'"
            @click="goOther('https://shop.qcos.cn/crm/login?redirect=')"
          >
            立即前往千橙分销PC端
          </div>
          <div
            class="submit-btn1"
            v-if="selectValueType == '10'"
            @click="goOther('https://szr.qcos.cn/#/login')"
          >
            立即前往千橙数字人PC端
          </div>
          <div
            class="submit-btn1"
            @click="goPath"
            v-if="
              selectValueType != '2' &&
              selectValueType != '4' &&
              selectValueType != '10' &&
              selectValueType != '5' &&
              selectValueType != '6'
            "
          >
            立即体验{{ productTitle[Number(selectValueType)] }}
          </div>
        </div>
      </div>
    </a-modal>
    <div id="captcha" />
  </div>
</template>

<script>
import { userRegister, sendRegisterSmsCaptcha } from "@/apis/index";
import md5 from "js-md5";
import { encryptDes, strToHexCharCode } from "@/utils/sign.js";
import { Input } from "ant-design-vue";
export default {
  name: "TryModal",
  props: {
    showLogin: {
      type: Boolean,
      default: false,
    },
    isLogin: {
      type: Boolean,
      default: false,
    },
    selectValue: {
      type: String,
      default: undefined,
    },
  },
  data() {
    const InputPassword = Input.Password;
    return {
        selectValueType:undefined,
      isChangeProduct: false,
      form: this.$form.createForm(this),
      countdown: 60,
      timer: "",
      isShowGetCode: true,
      captchaIns: null,
      params: null,
      isErr: false,
      infoSources: "汇通数科官网-首页",
      productTitle: [
        '',
        "千橙ERP",
        "千橙收银",
        "千橙连锁",
        "千橙微商城",
        "汇团团",
        "千橙分销",
        "千橙S2B2C",
        "千橙B2b分销",
        "汇好看直播",
        "千橙数字人",
      ],
    };
  },
  watch: {
    showLogin(val) {
      if (val) {
        console.log(val,'val')
        this.isErr = false;
      }
    },
  },
  mounted() {
    if (this.selectValue) {
      this.selectValueType = this.selectValue;
    }
    this.getCode();
    this.isChangeProduct = false;
    console.log(this.isErr,'isErr: false,')
  },
  methods: {
    changeProduct(e, options) {
      console.log(e, options);
    },
    goOther(page) {
      window.open(page, "_blank");
    },
    goPath() {
      if (this.selectValueType == "1" || this.selectValueType == "3") {
        window.open("https://shop.qcos.cn/login", "_blank");
      } else if (
        this.selectValueType == "2" ||
        this.selectValueType == "4" ||
        this.selectValueType == "10" ||
        this.selectValueType == "5" ||
        this.selectValueType == "6"
      ) {
        this.isLogin = true;
        return;
        // }else if(this.selectValueType == '6'){
        //     window.open('https://shop.qcos.cn/crm/login?redirect=', '_blank');
      } else if (
        this.selectValueType == "7" ||
        this.selectValueType == "8" ||
        this.selectValueType == "9"
      ) {
        window.open("https://store.qcos.cn/saas/#/login", "_blank");
      }
      this.$emit("cancel", false);
      this.captchaIns.refresh();
      this.form.resetFields();
    },
    checktelphone(rule, value, callback) {
      const reg = /^1[3456789]\d{9}$/;
      if (value && !reg.test(value)) {
        callback("请输入正确的手机号码！");
      } else {
        callback();
      }
    },
    checkPassword(rule, value, callback) {
      const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,32}$/;
      if (value && !reg.test(value)) {
        callback("支持8-32数字+字母组合密码!");
      } else {
        callback();
      }
    },
    handleSubmit(e) {
      e.preventDefault();
      if (this.selectValueType == "1") {
        this.infoSources = "汇通数科官网-千橙ERP";
      } else if (this.selectValueType == "2") {
        this.infoSources = "汇通数科官网-千橙收银";
      } else if (this.selectValueType == "3") {
        this.infoSources = "汇通数科官网-千橙连锁";
      } else if (this.selectValueType == "4") {
        this.infoSources = "汇通数科官网-千橙微商城";
      } else if (this.selectValueType == "5") {
        this.infoSources = "汇通数科官网-汇团团";
      } else if (this.selectValueType == "6") {
        this.infoSources = "汇通数科官网-千橙分销";
      } else if (this.selectValueType == "7") {
        this.infoSources = "汇通数科官网-千橙S2B2C";
      } else if (this.selectValueType == "8") {
        this.infoSources = "汇通数科官网-千橙B2b分销";
      } else if (this.selectValueType == "9") {
        this.infoSources = "汇通数科官网-汇好看直播";
      } else if (this.selectValueType == "10") {
        this.infoSources = "汇通数科官网-千橙数字人";
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          let password = encryptDes(values.password);
          password = strToHexCharCode(password);
          console.log(password, "strToHexCharCode加密返回数据");
          let registerSystem = "";
          if (
            this.selectValueType == "1" ||
            this.selectValueType == "2" ||
            this.selectValueType == "3" ||
            this.selectValueType == "4"
          ) {
            registerSystem = 1000;
          } else if (
            this.selectValueType == "7" ||
            this.selectValueType == "8" ||
            this.selectValueType == "9"
          ) {
            registerSystem = 2000;
          } else if (this.selectValueType == "10") {
            registerSystem = 3000;
          } else if (this.selectValueType == "5" || this.selectValueType == "6") {
            registerSystem = 9000;
          }
          const params = {
            registerSystem: registerSystem,
            storeName: values.storeName,
            userName: values.userName,
            phone: values.phone,
            password: password,
            messageCode: values.messageCode,
            infoSources: this.infoSources,
            officialWebsiteEntrance: "PC",
            informationExplain: values.informationExplain || "",
          };
          userRegister(params)
            .then((res) => {
              console.log(res, "提交注册返回参数");
              this.$message.success({
                content: "注册成功！",
                duration: 3,
              });
              // if(this.selectValueType == '1' || this.selectValueType == '3'){
              //     window.open('https://shop.qcos.cn/login', '_blank');
              // }else if(this.selectValueType == '2' || this.selectValueType == '4' || this.selectValueType == '10'){
              //     this.isLogin = true
              // }else if(this.selectValueType == '5'){
              //     this.isLogin = true
              // }else if(this.selectValueType == '6'){
              //     window.open('https://shop.qcos.cn/crm/login?redirect=', '_blank');
              // }else if(this.selectValueType == '7' || this.selectValueType == '8' || this.selectValueType == '9'){
              //     window.open('https://store.qcos.cn/saas/#/login', '_blank');
              // }else if(this.selectValueType == '10'){
              //     this.isLogin = true
              // }
              // this.$message.success({
              //   content: '感谢您的信息提交，我们将会有专员与您联系~',
              //   duration: 1
              // })
              this.isChangeProduct = true;
              this.goPath();
              // this.$emit('cancel', false)
              this.captchaIns.refresh();
              this.form.resetFields();
            })
            .catch((err) => {
              console.log(err, "提交失败");
              this.isChangeProduct = true;
              if (err == "该手机号已经是数科体系正式会员") {
                // if (
                //   this.selectValueType == "2" ||
                //   this.selectValueType == "4" ||
                //   this.selectValueType == "10" ||
                //   this.selectValueType == "5"
                // ) {
                //   this.isLogin = true;
                // } else {
                  this.isErr = true;
                // }
              }
              this.$message.error(err);
              this.captchaIns.refresh();
            });
        }
      });
    },
    handleCancel(e) {
      this.isChangeProduct = false
      this.form.resetFields();
      this.$emit("cancel", false);
      this.captchaIns.refresh();
      
    },
    sendMessage() {
      this.form.validateFields(["phone"], (errors, values) => {
        if (!errors) {
          this.params = values;
          this.captchaIns.popUp();
        }
      });
    },
    countDown() {
      const self = this;
      this.timer = setInterval(() => {
        self.countdown--;
        if (self.countdown === 0) {
          clearInterval(self.timer);
          self.countdown = 60;
          self.isShowGetCode = true;
          self.captchaIns.refresh();
        }
      }, 1000);
    },
    getCode() {
      const that = this;
      // eslint-disable-next-line no-undef
      initNECaptcha &&
        initNECaptcha(
          {
            element: "#captcha",
            captchaId: "6c0483e901164a789d9d13f0291ba257",
            mode: "popup",
            width: "320px",
            // enableClose: true,
            onClose: function () {
              // 弹出关闭结束后将会触发该函数
            },
            onVerify: function (err, data) {
              console.log(data, "滑块返回数据");
              if (err) return;
              that.params.pictureCode = data.validate;
              let registerSystem = "";
              console.log();
              if (
                that.selectValueType == "1" ||
                that.selectValueType == "2" ||
                that.selectValueType == "3" ||
                that.selectValueType == "4"
              ) {
                registerSystem = 1000;
              } else if (
                that.selectValueType == "7" ||
                that.selectValueType == "8" ||
                that.selectValueType == "9"
              ) {
                registerSystem = 2000;
              } else if (that.selectValueType == "10") {
                registerSystem = 3000;
              } else if (
                that.selectValueType == "5" ||
                that.selectValueType == "6"
              ) {
                registerSystem = 9000;
              }
              that.params.registerSystem = registerSystem;
              console.log(that.params, "获取验证码参数");
              sendRegisterSmsCaptcha(that.params)
                .then((data) => {
                  that.countDown();
                  that.isShowGetCode = false;
                })
                .catch((err) => {
                  that.$message.error(err);
                  that.captchaIns.refresh();
                });
            },
          },
          function (instance) {
            // 初始化成功后得到验证实例instance，可以调用实例的方法
            that.captchaIns = instance;
          },
          function (err) {
            console.log(err);
            // 初始化失败后触发该函数，err对象描述当前错误信息
          }
        );
    },
  },
};
</script>

<style lang="less" scoped>
// /deep/.ant-modal-centered .ant-modal{
//     transform: scale(70%);
//     top: 20%;
//     // left: -13%;
// }
/deep/.ant-modal-content {
  border-radius: 12px;
}
.toPath {
  width: 100%;
  margin-top: 160px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .code_img1 {
    width: 374px;
    height: 374px;
    margin-top: 48px;
  }
  .code_img2 {
    width: 340px;
    height: 488px;
    margin-top: 66px;
  }
  .code_text {
    // width: 336px;
    height: 33px;
    font-size: 24px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 33px;
    margin-top: 57px;
    text-align: center;
    // margin-bottom: 184px;
  }
  .submit-btn1 {
    width: 562px;
    height: 64px;
    background: #3986ff;
    border-radius: 4px;
    font-size: 20px;
    text-align: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 64px;
    margin-left: 11px;
    margin-top: 62px;
  }
  .product {
    width: 562px;
    height: 48px;
    display: flex;
    flex-direction: row;
    .product_label {
      width: 110px;
      height: 48px;
      font-size: 20px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 48px;
    }
    .product_value {
      height: 48px;
      font-size: 20px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 48px;
    }
  }
}
.modal-wrapper {
  height: 1010px;
}
.title {
  position: absolute;
  top: 0;
  left: 0;
  width: 662px;
  height: 213px;
  background: url("~@/assets/images/loginModal.png") no-repeat center;
  background-size: 100% 100%;
}
.form {
  width: 562px;
  margin: 158px 26px 0px 16px;
}
/deep/ .ant-form-item label {
  font-size: 20px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #333333;
}
/deep/ .ant-select {
  font-size: 16px;
}
/deep/ .ant-select-selection--single {
  height: 42px;
}
/deep/ .ant-select-selection__rendered {
  line-height: 42px;
}
/deep/ .ant-input {
  height: 42px;
}
/deep/ .ant-btn-lg {
  height: 42px;
}
/deep/ .ant-btn-lg {
  background: #f9fbfd;
}
/deep/ .submit-btn {
  width: 562px;
  height: 64px;
  background: #3986ff;
  border-radius: 12px;
  font-size: 20px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 64px;
  margin-left: 11px;
  margin-top: 60px;
}
.statement {
  font-size: 14px;
  font-weight: 400;
  color: #8b8fa1;
  line-height: 22px;
}
.count-down {
  background: #f9fbfd;
  color: rgba(0, 0, 0, 0.65);
  width: 112px;
}
</style>
